{/*export const CLIENTS = [
    { logo: 'https://i.postimg.cc/HssxLwP4/allotrix-logo.png', alt: 'Allotrix' }, 
]*/}

{/*export const STALLS = [
  { logo: 'https://i.postimg.cc/HssxLwP4/allotrix-logo.png', alt: 'Allotrix' }, 
]*/}

export const COMMITTEES = [
  
  { com: "ILC", logo: "https://i.ibb.co/gLhy9z3z/image-1.png" },
  { com: "UNHRC", logo: "https://i.ibb.co/bgxxbr9c/UNHRC-1.png" },
  
  { com: "IPP", logo: "https://i.ibb.co/1tVWxqcC/ip-1.png" },
  { com: "IPJ", logo: "https://i.ibb.co/1tVWxqcC/ip-1.png" },
  
  { com: "IMF", logo: "https://i.ibb.co/r2FPX0By/imf.png"  },
  { com: "AIPPM", logo: "https://i.ibb.co/C4nRtw9/aippm.png" },
  
  { com: "GENEVA", logo: "https://i.ibb.co/jkWx0zgS/geneva.png" },

  { com: "G20", logo: "https://i.ibb.co/8nBkr8L1/g20.png" },
];

export const AGENDAS = [
  
  { com: "ILC", logo: "https://i.ibb.co/9mGhDns4/2.png"},
  { com: "UNHRC", logo: "https://i.ibb.co/9Kg06qK/4.png"},
  
  { com: "G20", logo: "https://i.ibb.co/Yg7dy09/3.png"},
  { com: "AIPPM", logo: "https://i.ibb.co/05KTV06/5.png"},
  
  { com: "IMF", logo: "https://i.ibb.co/wFhDWS3T/6.png"},
  { com: "GENEVA", logo: "https://i.ibb.co/dwVgdLD0/7.png"},
  
  { com: "IPC", logo: "https://i.ibb.co/rfc7skGX/8.png"},

];

export const MUNPICS = [
    { img: 'https://i.ibb.co/M5Sb94MJ/IMG-20251104-WA0008.jpg', alt: '7' }, 
    { img: 'https://i.ibb.co/CsVTqw9T/IMG-20251104-WA0014.jpg', alt: '8' }, 
    { img: 'https://i.ibb.co/Hfr3MHrQ/IMG-20251104-WA0017.jpg', alt: '6' }, 
    { img: 'https://i.ibb.co/1Y2w0GmT/IMG-20251104-WA0021.jpg', alt: '1' },
    { img: 'https://i.ibb.co/tnMHCPC/IMG-20251104-WA0030.jpg', alt: '5' }, 


    { img: 'https://i.ibb.co/7NGK1rCc/IMG-20251104-WA0033.jpg', alt: '10' }, 
    { img: 'https://i.ibb.co/Fks8jKRC/IMG-20251104-WA0040.jpg', alt: '4' }, 
    { img: 'https://i.ibb.co/Z1N5F2Rs/IMG-20251104-WA0041.jpg', alt: '9' }, 

    { img: 'https://i.ibb.co/hTHzFWT/IMG-20251104-WA0038.jpg', alt: '3' }, 
    { img: 'https://i.postimg.cc/hGjkgDmn/12.webp', alt: '12' }, 

    { img: 'https://i.postimg.cc/FHGM2d7G/11.webp', alt: '11' }, 

];




export const EB1 = [
    {
      "name": "Anirudh S",
      "designation": "UNHRC (Co-Chair)",
      "img": "https://i.ibb.co/Cpy7Lmnc/Anirudh-S-HRC-Co-chair.jpg"
    },
    {
      "name": "Ashwamedh",
      "designation": "TGI (Vice Chair)",
      "img": "https://i.ibb.co/jZxgc04V/Ashwamedh-geneva-Vice-chair.jpg"
    },
    {
      "name": "Mohammad Azhar",
      "designation": "IPJ (Head of Journalism)",
      "img": "https://i.ibb.co/4n86dDCF/Azhar-IPJ-Head-of-photojournalism.jpg"
    },
    {
      "name": "Hariharasuthan",
      "designation": "AIPPM (Co-chair)",
      "img": "https://i.ibb.co/23L7K7W6/Hariharasuthan-AIPPM-Co-chair.jpg" 
    },
    {
      "name": "Harini Sree",
      "designation": "AIPPM (Co-chair)",
      "img": "https://i.ibb.co/sJJ2Nf83/Harini-Sree-AIPPM-Co-chair.jpg" 
    },
    
   
   
  ]
  export const EB2 = [

     {
      "name": "Hariroopan-Mathan",
      "designation": "ILC (Head-Chair)",
      "img": "https://i.ibb.co/tMsrX5TX/Hariroopan-Mathan-ILC-Head-Chair.jpg" 
    },
    {
        "name": "Jwala Ayer",
        "designation": "Editor in chief",
        "img": "https://i.ibb.co/Hf3Ns3BV/Jwala-IPJ-Co-photographer-in-chief.jpg" 
      },
      {
        "name": "Lokesh Narayana",
        "designation": "TGI (Head-chair)",
        "img": "https://i.ibb.co/27WQNqCn/Lokesh-narayana-Geneva-Head-chair.jpg" 
      },
      {
        "name": "Narendran MK",
        "designation": "Photographer in chief",
        "img": "https://i.ibb.co/W47bfL8b/Naren-IPP-Editor-in-Chief.jpg" 
      },
      {
        "name": "V Roshan Aravin",
        "designation": "TGI Moderator",
        "img": "https://i.ibb.co/cKjX3LGv/Roshan-geneva-moderator.jpg" 
      },
      
  ]

  export const EB3 = [
    {
        "name": "Sankrushi PS",
        "designation": "IPP (Head of Photography)",
        "img": "https://i.ibb.co/W4FvGN7z/Sankrushi-IPP-Head-of-journalism.jpg"
      },
      {
        "name": "Shreya",
        "designation": "ILC (Vice-Chair)",
        "img": "https://i.ibb.co/RGDGjM85/Shreya-ILC-Vice-Chair.jpg"
      },
      {
        "name": "Sowmiya Narayanan",
        "designation": "HRC (Co-Chair)",
        "img": "https://i.ibb.co/F4s89LnD/Sowmiya-Narayanan-HRC-Co-Chair.jpg" 
      },
      {
        "name": "Swayam Krishnan",
        "designation": "HRC (Co-chair)",
        "img": "https://i.ibb.co/Z1bV9MmR/Swayam-Krishnan-HRC-Co-chair.jpg" 
      },
      {
        "name": "Jamal",
        "designation": "G20 Director",
        "img": "https://i.ibb.co/qLs4RXLv/Whats-App-Image-2025-07-21-at-22-04-08.jpg" 
      },
      {
        "name": "Vibhu, Akhil",
        "designation": "G20 (Co - Chairs)",
        "img": "https://i.ibb.co/1JL66Db4/Vibhu-Akhil-G20-Chairs.jpg" 
      },

     
  ]

   export const EB4 = [
    {
        "name": "H Shyam Sundar",
        "designation": " AIPPM  (Vice chair)",
        "img": "https://i.ibb.co/RwpXSLL/Whats-App-Image-2025-07-05-at-23-18-09.jpg"
      },
      {
        "name": "Karan Chordia",
        "designation": "IMF  (co vice chair)",
        "img": "https://i.ibb.co/fVbQQcN6/Whats-App-Image-2025-07-05-at-23-18-09-1.jpg"
      },
{
        "name": "Sajith Rayhan",
        "designation": "IMF (Co- Vice Chair)",
        "img": "https://i.ibb.co/Vp32Jt0s/Sajith-Rayhan-IMF-Co-vice-chair.jpg" 
      },
{
        "name": "Ruchit Shivani",
        "designation": "IMF (Chair)",
        "img": "https://i.ibb.co/rRKVNBLP/Ruchith-IMF-Head-Chair.jpg" 
      },
 {
        "name": "Vihaan Reddy",
        "designation": "TGI (Co-vice Chair)",
        "img": "https://i.ibb.co/PZw2tJGL/Vihaan-geneva-co-vice-chair.jpg" 
      },
      
     
  ]
  export const EB5 = [
    {
        "name": "Karan Chordia",
        "designation": "ECOSOC (CO Head Chair)",
        "img": "https://i.postimg.cc/VkdJbqV9/IMG-26.png"
      },
      {
        "name": "Yohan Tharakan",
        "designation": "US Senate (Co Vice Chair)",
        "img": "https://i.postimg.cc/SQfY0N99/IMG-27.png"
      },
      {
        "name": "Atul Raj Sokhi",
        "designation": "UNSC (Head Chair)",
        "img": "https://i.postimg.cc/63NqSD5z/IMG-28.png"
      },
      {
        "name": "Dhaksh",
        "designation": "UNGA",
        "img": "https://i.postimg.cc/N0mjgPkd/IMG-29.jpg"
      },
      {
        "name": "Soham N Mutta",
        "designation": "UNGA",
        "img": "https://i.postimg.cc/bJFxjC7M/IMG-10.jpg"
      },
      {
        "name": "Rohith Raman",
        "designation": "US Senate (Head Chair)",
        "img": "https://i.postimg.cc/hG2x9Ztj/IMG-12.jpg"
      },
  ]

  export const OC1 = [
    {
      "name": "Sanjeev Chandrashekar",
      "designation": "Co-Head of Organising Committee",
      "img": "https://i.ibb.co/SDdPrjN0/Whats-App-Image-2025-07-16-at-22-29-01-1.jpg"
    },
   {
      "name": "Krishaanth S",
      "designation": "Co-head of organising committee",
      "img": "https://i.ibb.co/v6mQL3X1/c8ac8702-036e-4759-8303-31091370eb2f.jpg"
    },
    {
      "name": "Akansha Arun",
      "designation": "USG Hospitality",
      "img": "https://i.ibb.co/213sXQqp/0eacbec0-836a-401c-a656-26d5f4690683.jpg" 
    },
    {
      "name": "Kulvansh Surana",
      "designation": "Head of Sponsorship",
      "img": "https://i.ibb.co/84n3hGn9/cb3d23ae-8ceb-4a4a-9b8b-b90f6a79746a.jpg" 
    },
    {
      "name": "Reeth Mokati",
      "designation": "USG Decor Team Member",
      "img": "https://i.ibb.co/vxRwx87R/3c224ab8-e1a3-40d3-b735-48ba1b75d56f.jpg" 
    },
  ]

  export const OC2 = [
    {
      "name": "Tanishka Karan",
      "designation": "USG Decor team member",
      "img": "https://i.ibb.co/4Rb6RNgt/a4c47c8a-eea0-4e40-b563-cfa04c3144b2.jpg" 
    },
    {
      "name": "Rakshana S",
      "designation": "USG Head of Decor",
      "img": "https://i.ibb.co/BHjSf6Sj/25853ff1-eb50-4973-a05a-dca1a9befec7.jpg"
    },
    {
      "name": "Kaviya Sri",
      "designation": "USG Decor team member",
      "img": "https://i.ibb.co/DPyBzNnR/9b9d4b76-797f-48be-92ec-123d81b578a3.jpg" 
    },
    {
      "name": "Prajith S",
      "designation": "Head of Website Development",
      "img": "https://i.ibb.co/gM8CMhRR/f157fba1-2876-4e7f-bd3d-3ebfc5291d9e.jpg"
    },
    {
      "name": "Nandana",
      "designation": "USG Co-head Content writing",
      "img": "https://i.ibb.co/QFPwktzM/2e201a5d-cc47-4679-b945-514c2e800ac1.jpg" 
    },
    {
      "name": "Vridhi Jain",
      "designation": "USG content",
      "img": "https://i.ibb.co/Fkw67rV7/5760b764-e1e0-4480-92a7-5d368724cf99.jpg"
    },
   
  ]

  export const OC3 = [
    {
      "name": "Srihitha S",
      "designation": "USG Marketing team member",
      "img": "https://i.ibb.co/5WFr7dK6/Screenshot-2025-07-18-190920.jpg"
    },
    {
      "name": "Rithika Harish",
      "designation": "USG Co-head Content Writing Team",
      "img": "https://i.ibb.co/QzVf0DG/3a90c099-e38b-4877-b0ea-efe31e6961cf.jpg"
    },
    {
      "name": "A Neha Rozane ",
      "designation": "USG Content writing",
      "img": "https://i.ibb.co/LHJtv67/a638c0ac-0cf7-407a-bbc2-95ea2ac32e40.jpg" 
    },
    {
      "name": "Bhavyan A Chauhan",
      "designation": "USG Sponsorship",
      "img": "https://i.ibb.co/NnpD9fSy/ea4a93de-d9c5-47f2-83de-85e31678e631.jpg" 
    },
    {
      "name": "Kristina Susanna R C",
      "designation": "USG Head of Logistics",
      "img": "https://i.ibb.co/zHTh9bxh/d882211e-d2fa-48b5-bcb7-ea0b70ff44d9.jpg"
    },
    
  ]

  export const OC4 = [
    {
      "name": "Hardik M Sooda",
      "designation": "USG Head of Tech and Viscom",
      "img": "https://i.ibb.co/WWpJYFG5/c0b51f85-c953-4b1d-97c9-5bb7e067539a.jpg"
    },
    {
      "name": "Nehan M Shahal",
      "designation": " USG Head of Marketing",
      "img": "https://i.ibb.co/67r1bPTF/621965b9-cca3-4149-ab85-b2b33c2e7b90.jpg" 
    },
    {
      "name": "Mohnish Maaran",
      "designation": "USG Team Member for Tech and Viscom",
      "img": "https://i.ibb.co/7tNqzyQ7/3e5cc4b1-a655-481a-8833-cf6076e4d010.jpg"
    },
    {
      "name": "Hamsini",
      "designation": "USG hospitality",
      "img": "https://i.ibb.co/mFtCR4HN/1c668955-68ce-441f-a73c-d3bec64932dd.jpg" 
    },

     {
      "name": "Daksh",
      "designation": "USG Marketing Team member",
      "img": "https://i.ibb.co/tw2MJqTv/d70d9e3b-ef7b-4239-a378-5de3aba766ae.jpg" 
    },
    
    {
      "name": "Saahas",
      "designation": "USG delegate affairs",
      "img": "https://i.ibb.co/XZgPG8s6/37ca4045-4855-456b-bc83-850f0b5bd2e3.jpg" 
    },
   
  ]